import { render, staticRenderFns } from "./ClueItem.vue?vue&type=template&id=4d83978d&scoped=true&"
import script from "./ClueItem.vue?vue&type=script&lang=js&"
export * from "./ClueItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83978d",
  null
  
)

export default component.exports